


// import React from "react";

// const Erpsolution = () => {
//   return (
//     <div style={styles.container}>
//       <div style={styles.imageSection}>
//         <img src="/image/customai2.webp" alt="ERP Solutions" style={styles.image} />
//       </div>
//       <div style={styles.textSection}>
//         <h2 style={styles.title}>Empower Your Operations with Custom AI</h2>
//         <p style={styles.description}>
//          Our custom AI solutions are designed to address the specific needs of your business, 
//          improving efficiency, optimizing processes, and unlocking new growth opportunities.
//         </p>
//         <p style={styles.description}>
//          We offer end-to-end AI services, from strategy and design to implementation and ongoing optimization.
//           Whether you're looking to automate processes, gain insights from data, or build intelligent systems,
//            we have you covered with AI solutions tailored to your business goals.
//         </p>
//         <p style={styles.description}>
//          By leveraging cutting-edge machine learning models, natural language processing,
//           and computer vision, we create AI-powered solutions that deliver measurable results. 
//           Our approach ensures that each solution is aligned with your unique requirements,
//            driving business transformation and sustainable growth.
//         </p>
        
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "40px 5%",
//     backgroundColor: "white",
//     boxSizing: "border-box",
//     flexWrap: "wrap",
//   },
//   textSection: {
//     width: "50%",
//     paddingLeft: "40px",
//     textAlign: "left",
//   },
//   title: {
//     fontSize: "32px",
//     fontWeight: "bold",
//     marginBottom: "20px",
//     color: "black",
//   },
//   description: {
//     fontSize: "16px",
//     lineHeight: "1.6",
//     marginBottom: "15px",
//     textAlign: "justify",
//     color: "black",
//   },
//   imageSection: {
//     width: "45%",
//     textAlign: "center",
//   },
//   image: {
//     width: "100%",
//     maxWidth: "600px",
//     height: "auto",
//     borderRadius: "8px",
//   },
//   "@media (max-width: 768px)": {
//     container: {
//       flexDirection: "column",
//       padding: "20px",
//     },
//     textSection: {
//       width: "100%",
//       paddingLeft: "0",
//       order: 2,
//     },
//     imageSection: {
//       width: "100%",
//       order: 1,
//       marginBottom: "30px",
//     },
//     title: {
//       fontSize: "28px",
//       textAlign: "center",
//     },
//     description: {
//       fontSize: "14px",
//       textAlign: "left",
//     },
//   },
//   "@media (max-width: 480px)": {
//     title: {
//       fontSize: "24px",
//     },
//     description: {
//       fontSize: "13px",
//     },
//   },
// };

// // Convert the styles object to inline styles and media queries
// const responsiveStyles = `
//   @media (max-width: 768px) {
//     .erp-container {
//       flex-direction: column;
//       padding: 20px;
//     }
//     .erp-text-section {
//       width: 100%;
//       padding-left: 0;
//       order: 2;
//     }
//     .erp-image-section {
//       width: 100%;
//       order: 1;
//       margin-bottom: 30px;
//     }
//     .erp-title {
//       font-size: 28px;
//       text-align: center;
//     }
//     .erp-description {
//       font-size: 14px;
//       text-align: left;
//     }
//   }
//   @media (max-width: 480px) {
//     .erp-title {
//       font-size: 24px;
//     }
//     .erp-description {
//       font-size: 13px;
//     }
//   }
// `;

// export default Erpsolution;



import React from "react";

const Erpsolution = () => {
  return (
    <>
      <style>
        {`
          .erp-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 40px 5%;
            background-color: white;
            box-sizing: border-box;
            flex-wrap: wrap;
          }

          .erp-text-section {
            width: 50%;
            padding-left: 40px;
            text-align: left;
          }

          .erp-title {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 20px;
            color: black;
          }

          .erp-description {
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: justify;
            color: black;
          }

          .erp-image-section {
            width: 45%;
            text-align: center;
          }

          .erp-image {
            width: 100%;
            max-width: 600px;
            height: auto;
            border-radius: 8px;
          }

          /* Tablet view */
          @media (max-width: 768px) {
            .erp-container {
              flex-direction: column;
              padding: 20px;
            }
            .erp-text-section {
              width: 100%;
              padding-left: 0;
              order: 2;
            }
            .erp-image-section {
              width: 100%;
              order: 1;
              margin-bottom: 30px;
            }
            .erp-title {
              font-size: 28px;
              text-align: center;
            }
            .erp-description {
              font-size: 14px;
              text-align: left;
            }
          }

          /* Mobile view */
          @media (max-width: 480px) {
            .erp-title {
              font-size: 24px;
            }
            .erp-description {
              font-size: 13px;
            }
          }
        `}
      </style>

      <div className="erp-container">
        <div className="erp-image-section">
          <img
            src="/image/customai2.webp"
            alt="ERP Solutions"
            className="erp-image"
          />
        </div>
        <div className="erp-text-section">
          <h2 className="erp-title">Empower Your Operations with Custom AI</h2>
          <p className="erp-description">
            Our custom AI solutions are designed to address the specific needs of your business, 
            improving efficiency, optimizing processes, and unlocking new growth opportunities.
          </p>
          <p className="erp-description">
            We offer end-to-end AI services, from strategy and design to implementation and ongoing optimization.
            Whether you're looking to automate processes, gain insights from data, or build intelligent systems,
            we have you covered with AI solutions tailored to your business goals.
          </p>
          <p className="erp-description">
            By leveraging cutting-edge machine learning models, natural language processing,
            and computer vision, we create AI-powered solutions that deliver measurable results. 
            Our approach ensures that each solution is aligned with your unique requirements,
            driving business transformation and sustainable growth.
          </p>
        </div>
      </div>
    </>
  );
};

export default Erpsolution;
